interface LocalStorageDictionary {
  CREDIT_BOOK_TOKEN: LocalStorageKey;
  PORTAL_PREFERENCE: LocalStorageKey;
  // PORTAL_PROFILE is no longer used, but kept for backward compatibility
  PORTAL_PROFILE: LocalStorageKey;
}

export type LocalStorageKey = keyof LocalStorageDictionary;

export const localStorageDictionary: LocalStorageDictionary = {
  CREDIT_BOOK_TOKEN: 'CREDIT_BOOK_TOKEN',
  PORTAL_PREFERENCE: 'PORTAL_PREFERENCE',
  // PORTAL_PROFILE is no longer used, but kept for backward compatibility
  PORTAL_PROFILE: 'PORTAL_PROFILE',
};

export const setLocalStorage = (
  key: LocalStorageKey,
  value: object | string,
) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorage = (key: LocalStorageKey) => {
  const value = localStorage.getItem(key);

  return value ? JSON.parse(value) : null;
};

export const clearLocalStorage = (key: LocalStorageKey) => {
  localStorage.removeItem(key);
};
